import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledPageHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  max-width: 2000px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  min-height: 106px;
`;
